import { render } from "./add_system_user_modal.vue?vue&type=template&id=22107c21&scoped=true"
import script from "./add_system_user_modal.vue?vue&type=script&lang=js"
export * from "./add_system_user_modal.vue?vue&type=script&lang=js"

import "./add_system_user_modal.vue?vue&type=style&index=0&id=22107c21&scoped=true&lang=css"

import exportComponent from "/home/denoh/aiwork/second/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22107c21"]])

export default __exports__